export const GET_CHARGEBACK_MONITORING_LIST = "GET_CHARGEBACK_MONITORING_LIST"
export const GET_CHARGEBACK_MONITORING_LIST_SUCCESS = "GET_CHARGEBACK_MONITORING_LIST_SUCCESS"
export const GET_CHARGEBACK_MONITORING_LIST_FAIL = "GET_CHARGEBACK_MONITORING_LIST_FAIL"

export const GET_CHARGEBACK_MONITORING_SEARCH = "GET_CHARGEBACK_MONITORING_SEARCH"
export const GET_CHARGEBACK_MONITORING_SEARCH_SUCCESS = "GET_CHARGEBACK_MONITORING_SEARCH_SUCCESS"
export const GET_CHARGEBACK_MONITORING_SEARCH_FAIL = "GET_CHARGEBACK_MONITORING_SEARCH_FAIL"

export const CHARGEBACK_MONITORING_API_ERROR = "CHARGEBACK_MONITORING_API_ERROR"